import { GlobalEnumsAceXfoundportalobjekt, PortalzugriffDisplayModel, UserDisplayModel } from '@/api/model-index';
import { PortalzugriffService } from '@/api/service-index';
import { PortalContextService } from '@/core/services/portal-context.service';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { PagerSettings } from '@progress/kendo-angular-listview';
import { emailValidator } from '@/core/validators/customform.validators';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { AnfrageLiveSharingService } from '@/core/services/anfrage-live-sharing.service';
import { FreigebenSendEmailFailedNotification } from '@/core/utils/notifications/freigeben/freigeben-send-email-failed.notification';
import { FocusService } from '@/core/services/focus.service';

@Component({
  selector: 'app-freigeben-dialog',
  templateUrl: './freigeben-dialog.component.html',
  styleUrls: ['./freigeben-dialog.component.scss']
})
export class FreigebenDialogComponent extends ConfirmationDialogComponent {

  @Input() 
  public portalzugriffe: PortalzugriffDisplayModel[] = [];
  @Input() 
  public users: UserDisplayModel[] = [];
  @Input()
  public showLiveUsers: boolean = false;
  @Input()
  public anfrageId: string;
  @Input()
  public scope: GlobalEnumsAceXfoundportalobjekt;
  @Input()
  public anfrageTitel: string | null;

  public usersOfInstitution: PortalzugriffDisplayModel[] = [];
  public searchResultEmail: PortalzugriffDisplayModel[] = [];

  public searchControlEmail: FormControl;
  public loading: boolean;

  public subtext: string = "";

  public livePortalzugriffe: PortalzugriffDisplayModel[] = [];

  public originalPortalzugriffe: PortalzugriffDisplayModel[] = [];

  @ViewChild('clickDummy') clickDummyRef: ElementRef;

  public pagerSettings: PagerSettings = {
    previousNext: false,
    pageSizeValues: false,
    buttonCount: 9,
  };
  public pageSize = 4;

  get isVorschlaegeVisible(): boolean {
    return this.users != null && this.users.length > 1;
  }

  get isSingleColumn(): boolean {
    return !this.isVorschlaegeVisible && !this.showLiveUsers;
  }

  get dynamicPageSize(): number {
    if(this.showLiveUsers && this.isVorschlaegeVisible) {
      return 10;
    }
    return 4;
  }

  get isListDirty(): boolean {
    return this.originalPortalzugriffe.length != this.portalzugriffe.length || this.originalPortalzugriffe.some(originalPortalzugriff => !this.portalzugriffe.some(portalzugriff => portalzugriff.id == originalPortalzugriff.id));
  }

  constructor(dialog: DialogRef, protected portalzugriffService: PortalzugriffService, protected portalContextService: PortalContextService, protected loadingAnimationService: LoadingAnimationService, protected anfrageLiveSharingService: AnfrageLiveSharingService, protected focusService: FocusService) {
    super(focusService,dialog);
  }

  protected updateLivePortalzugriffe(values: string[]): void {
    let updatedList: PortalzugriffDisplayModel[] = [];
    if (this.users) {
      this.users.forEach(user => {
        if (values.find(email => email == user.username)) {
          let zugriff = new PortalzugriffDisplayModel();
          zugriff.externerBenutzer = user;
          zugriff.isPrimaererExternerBenutzer = true;
          updatedList.push(zugriff);
        }
      })
    }

    values.forEach(email => {
      if (!updatedList.find(zugriff => zugriff.externerBenutzer?.username == email)) {
        let zugriff = new PortalzugriffDisplayModel();
        zugriff.unregistrierterBenutzer = email;
        zugriff.isPrimaererExternerBenutzer = true;
        updatedList.push(zugriff);
      }
    })

    this.livePortalzugriffe = updatedList;
    if (document.getElementById("blazor-anfrage-sharing") != null)
      (document.getElementById("blazor-anfrage-sharing") as HTMLElement).click();
  }

  ngOnInit(): void {
    this.originalPortalzugriffe = Object.assign([], this.portalzugriffe);
    this.anfrageLiveSharingService.livePortalzugriffeBehavior.asObservable().subscribe(values => {
      this.updateLivePortalzugriffe(values);
    })
    this.updateLivePortalzugriffe(this.anfrageLiveSharingService.livePortalzugriffe);

    if (this.users) {
      this.users.forEach(user => {
        if (this.portalzugriffe.find(zugriff => zugriff.externerBenutzer?.username == user.username || zugriff.unregistrierterBenutzer == user.username) == undefined) {
          let zugriff = new PortalzugriffDisplayModel();
          zugriff.externerBenutzer = user;
          this.usersOfInstitution.push(zugriff);
        }
      })
    }

    this.searchControlEmail = new FormControl();
    this.searchControlEmail.addValidators(emailValidator);
    this.searchControlEmail.valueChanges.subscribe(value => this.searchControlEmailUpdate(value));
  }

  protected searchControlEmailUpdate(value: string): void {
    if (value.length > 3) {
      let result = new PortalzugriffDisplayModel();
      result.unregistrierterBenutzer = value;
      this.searchResultEmail = [result];

      if (this.portalzugriffe.find(zugriff => zugriff.externerBenutzer?.username?.toLowerCase() == value.toLowerCase().trim() || zugriff.unregistrierterBenutzer?.toLowerCase() == value.toLowerCase().trim())) {
        this.subtext = "freigebendialog.userexists";
      }
      else if(this.searchControlEmail.invalid) {
        this.subtext = "freigebendialog.userinvalid";
      }
      else {
        this.subtext = ""
      }
    }
    else {
      this.searchResultEmail = [];
    }
  }

  public addAvatar(avatar: PortalzugriffDisplayModel, vorschlagsliste: boolean): void {
    let foundUserOfInstitutionIndex = this.usersOfInstitution.findIndex(zugriff => {
      if (vorschlagsliste)
        return zugriff.externerBenutzer?.username == avatar.externerBenutzer?.username;
      else
        return zugriff.externerBenutzer?.username == avatar.unregistrierterBenutzer;
    });

    if (foundUserOfInstitutionIndex >= 0) {
      this.portalzugriffe.push(this.usersOfInstitution[foundUserOfInstitutionIndex]);
      this.usersOfInstitution.splice(foundUserOfInstitutionIndex, 1);
      this.usersOfInstitution = JSON.parse(JSON.stringify(this.usersOfInstitution));
    }
    else {
      this.portalzugriffe.push(avatar);
    }

    this.portalzugriffe = JSON.parse(JSON.stringify(this.portalzugriffe));

    //Reset the email input field, but at first focus at dummy and wait, because the edge browser build-in recommendation dropdown would reverse the reset
    this.clickDummyRef.nativeElement.focus();
    this.searchControlEmailUpdate("");
    setTimeout(() => {
      this.searchControlEmail.patchValue("", {emitEvent: false});
    }, 100);
  }

  public removeAvatar(avatar: PortalzugriffDisplayModel): void {
    this.portalzugriffe = this.portalzugriffe.filter(zugriff => zugriff != avatar);
    if (!avatar.unregistrierterBenutzer) {
      this.usersOfInstitution.push(avatar);
      this.usersOfInstitution = JSON.parse(JSON.stringify(this.usersOfInstitution));
    }
  }

  override onConformClick(): void {
    let subscription = this.portalzugriffService.apiPortalzugriffAnfrageIdPatch({anfrageId: this.anfrageId, "x-anfragescope": this.scope, body: this.portalzugriffe}).subscribe(() => {
      this.dialog.close();
    }, err => {
      if (err.error.Errors && err.error.Errors.length > 0 && err.error.Errors[0].Message == "FreigebenSendEmailFailedException") {
        this.dialog.close();
        throw new FreigebenSendEmailFailedNotification();
      }
      else {
        throw err;
      }
    });

    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }

  public onSearchEmailKeyDown(event: KeyboardEvent): void {
    if (event.key == "Enter") {
      if (this.searchResultEmail.length > 0 && !this.subtext) {
        this.addAvatar(this.searchResultEmail[0], false);
      }
    }
  }

  public dynamicSkip: number = 0;
}